<div class="vex-user-menu">
    <a
        (click)="close()"
        [routerLink]="['/apps/social/timeline']"
        class="vex-user-menu-item"
        matRipple
        matRippleColor="rgb(var(--vex-color-primary-600), 0.1)"
    >
        <mat-icon class="vex-user-menu-item__icon icon-sm">lock</mat-icon>
        <div class="vex-user-menu-item__label">Lockscreen</div>
    </a>
    <a
        (click)="close()"
        [routerLink]="['/settings']"
        class="vex-user-menu-item"
        matRipple
        matRippleColor="rgb(var(--vex-color-primary-600), 0.1)"
    >
        <mat-icon class="vex-user-menu-item__icon icon-sm">settings</mat-icon>
        <div class="vex-user-menu-item__label">Settings</div>
    </a>

    <div class="border-b border-divider mx-4"></div>

    <a
        (click)="logout()"
        class="vex-user-menu-item text-danger"
        matRipple
        matRippleColor="rgb(var(--vex-color-primary-600), 0.1)"
    >
        <mat-icon class="vex-user-menu-item__icon icon-sm">logout</mat-icon>
        <div class="vex-user-menu-item__label">Sign Out</div>
    </a>
</div>
